<template>
  <van-pull-refresh
    v-model="isLoading"
    @refresh="onPullDownRefresh"
  >
    <div
      class="leaderboard"
      v-if="state == 1 && csType == 1"
    >
      <div class="leaderboard-header">
        <img
          :src="prefixURL + 'rank_banner.png'"
          alt=""
          width="100%"
          height="100%"
        >
      </div>
      <div class="leaderboard-main">
        <div class="leaderboard-label"><span>每周参与排行榜，赢巨额大礼</span></div>
        <div class="leaderboard-title">
          <i></i>
          <b>销售额排行榜</b>
          <i></i>
        </div>
        <van-count-down
          :time="leaderboardInfo.countDown * 1000"
          class="leaderboard-timer"
          @finish="finish"
        >
          <template #default="timeData">
            <span>活动倒计时</span>
            <span>{{timeData.days}}</span>
            <span>天</span>
            <span>{{ timeData.hours | timer }}</span>
            <span>时</span>
            <span>{{ timeData.minutes | timer }}</span>
            <span>分</span>
            <span>{{ timeData.seconds | timer }}</span>
            <span>秒</span>
          </template>
        </van-count-down>
        <div class="leaderboard-user">
          <div class="leaderboard-item leaderboard-self">
            <span>排名</span>
            <span>奖励</span>
            <span>销售额</span>
            <span>获奖社区</span>
          </div>
          <template v-if="leaderboardList.length">
            <div class="leaderboard-list">
              <div
                class="leaderboard-item"
                style="color: #333333"
                v-for="(item,index) in leaderboardList"
                :key="index"
              >
                <span :class="{'leaderboard-me':leaderboardInfo.self.rank == item.rank}">
                  <img
                    :src="require(`../../assets/img/top${index + 1}.png`)"
                    alt
                    v-if="index < 3"
                  >{{item.rank > 3 ? item.rank : ''}}
                </span>
                <span class="van-ellipsis">{{item.award}}</span>
                <span>****元</span>
                <span>{{item.csName}}</span>
              </div>
            </div>
            <div
              class="leaderboard-item leaderboard-self"
              v-if="leaderboardInfo.self.rank > 0"
            >
              <span v-if="userType == 1"><b>{{leaderboardInfo.self.rank}}</b></span>
              <span v-else>{{leaderboardInfo.self.rank}}</span>
              <span class="van-ellipsis">{{leaderboardInfo.self.award == "" ? "0元" : leaderboardInfo.self.award}}</span>
              <span>{{leaderboardInfo.self.salesAmount}}元</span>
            </div>
          </template>
          <template v-else>
            <div class="notLeaderboard">
              <img
                src="../../assets/img/has_not_started.png"
                alt=""
              >
            </div>
          </template>
          <template v-if="userType == 1">
            <div
              class="leaderboard-item leaderboard-self leaderboard-differ"
              v-if="leaderboardInfo.self.rank > 0"
            >
              {{leaderboardInfo.self.differ}}
            </div>
            <div
              class="leaderboard-item leaderboard-self"
              style="justify-content: center"
              v-else
            >
              本周暂无用户在我的社区下单哦～
            </div>
          </template>
        </div>
        <div
          class="leaderboard-awarded"
          @click="goToDealis('/shopAwardList')"
        >
          查看历史获奖名单>>
        </div>
      </div>
      <div class="leaderboard-main">
        <div class="leaderboard-label"><span>活动规则</span></div>
        <div class="rule-image">
          <img
            :src="prefixURL + 'rankRuleInfo.png'"
            alt=""
          >
        </div>
      </div>
    </div>
    <div
      class="notHave"
      v-if="state == 0 || csType == 2"
    >
      <img
        :src="prefixURL + 'shopActivity.png'"
        alt=""
        width="100%"
        height="100%"
        style="display: block"
      >
    </div>
  </van-pull-refresh>
</template>

<script>
import { shopTopList, getState, myShop } from "@/api/join";
export default {
  data() {
    return {
      active: 0,
      state: 0,//1 表示开启活动，0表示关闭活动
      leaderboardList: [],
      leaderboardInfo: {
        self: {},
        countDown: 666
      },
      communityShopId: "", // 社区店ID
      userType: "", // 用户的店长类型：1正店长，2副店长
      csType: 1, // 1、社区 2、校区
      isLoading: true,
    }
  },
  filters: {
    timer(val) {
      if (val < 10) {
        val = "0" + val;
      }
      return val;
    }
  },
  methods: {
    onPullDownRefresh() {
      this.getTopList();
    },
    subtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      //动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    goToDealis(value) {
      this.$router.push(value);
    },
    // 倒计时结束
    finish() {
      this.getTopList();
    },
    getTopList() {
      if (this.csType == 2) {
        // 校区不展示排行榜
        setTimeout(() => {
          this.isLoading = false;
        }, 1000)
        return false;
      };
      shopTopList({
        page: {
          way: "0", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        csId: this.communityShopId,
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            const list = res.content.list;
            const self = res.content.self;
            if (list.length) {
              let difference;
              // 判断店长是否上榜
              if (list[list.length - 1].rank * 1 >= self.rank * 1) {
                // 判断店长上榜后 排名是否是第一名
                if (self.rank * 1 > 1) {
                  // 判断店长排行与前一名销售额差是否为0 为0 就显示0.01
                  if (this.subtr(list[self.rank - 2].salesAmount, self.salesAmount) > 0) {
                    difference = this.subtr(list[self.rank - 2].salesAmount, self.salesAmount);
                  } else {
                    difference = 0.01;
                  }
                  self.differ = `与前一名销售额差${difference}元`;
                } else {
                  self.differ = "当前排名第一名，继续保持哦~";
                }
              } else {
                // 判断店长排行与排行榜最后一名销售额差是否为0 为0 就显示0.01
                if (this.subtr(list[list.length - 1].salesAmount, self.salesAmount) > 0) {
                  difference = this.subtr(list[list.length - 1].salesAmount, self.salesAmount);
                } else {
                  difference = 0.01;
                }
                self.differ = `距离上榜销售额差${difference}元`;
              }
            }
            this.isLoading = false;
            this.leaderboardList = list;
            this.leaderboardInfo = res.content;
          }
        })
    },
  },
  mounted() {
    getState({
      type: "1" //0用户排行榜，1店长排行榜，不传默认0
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.state = res.content.state;
      }
    })
    myShop({
      leastOpenTime: localStorage.getItem("leastOpenTime") ? localStorage.getItem("leastOpenTime") : "2020-04-04 04:04:04",
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.csType = res.content.csType;
        this.userType = res.content.userType;
        this.communityShopId = res.content.communityShopId;
        this.getTopList();
      }
    });
  },
  activated() {
    if (this.communityShopId != "") this.getTopList();
  }
}
</script>

<style lang="scss" scoped>
.leaderboard {
  padding-bottom: 73px;
  background-color: #221815;
  .leaderboard-header {
    position: relative;
  }
  .leaderboard-main {
    width: 355px;
    margin: 5px auto 0;
    background-color: #ffffff;
    border-radius: 10px;
    .leaderboard-label {
      font-size: 16px;
      text-align: center;
      span {
        height: 24px;
        line-height: 24px;
        display: inline-block;
        padding: 0 9px;
        color: #ffffff;
        background-color: #e4bf93;
        border-radius: 0px 0px 10px 10px;
      }
    }
  }
  .leaderboard-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    b {
      font-size: 24px;
      color: #333333;
    }
    i {
      width: 55px;
      height: 3px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      &:first-child {
        left: 41px;
        background: linear-gradient(90deg, #ffffff 0%, #737373 100%);
      }
      &:last-child {
        right: 41px;
        background: linear-gradient(297deg, #ffffff 0%, #737373 100%);
      }
    }
  }
  .leaderboard-timer {
    text-align: center;
    margin-top: 10px;
    span {
      &:nth-of-type(odd) {
        margin-right: 3px;
        font-size: 13px;
        font-weight: bold;
        color: #666666;
      }
      &:nth-of-type(even) {
        width: 24px;
        height: 24px;
        line-height: 24px;
        display: inline-block;
        margin-right: 3px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
        background-color: #e4bf93;
        border-radius: 5px;
      }
    }
  }
  .leaderboard-user {
    width: 335px;
    margin: 12px auto 0;
    overflow: hidden;
    border: 1px solid #e2bd8d;
    box-sizing: border-box;
  }
  .leaderboard-item {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    span {
      height: 35px;
      line-height: 35px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      position: relative;
      border-bottom: 1px solid #e2bd8d;
      &:nth-child(1) {
        width: 55px;
        text-align: center;
        border-right: 1px solid #e2bd8d;
      }
      &:nth-child(2) {
        width: 76px;
        padding: 0 5px;
        border-right: 1px solid #e2bd8d;
      }
      &:nth-child(3) {
        width: 60px;
        padding: 0 5px;
        border-right: 1px solid #e2bd8d;
      }
      &:nth-child(4) {
        width: 116px;
        padding: 0 5px;
      }
    }
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
    }
  }
  .leaderboard-me {
    position: relative;
    &::after {
      content: "我";
      position: absolute;
      top: 3px;
      right: 7px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      font-size: 11px;
      color: #ffffff;
      border-radius: 50%;
      background-color: #d2934f;
    }
  }
  .leaderboard-self {
    background-color: #e2bd8d;
    span {
      border-right-color: #ffffff !important;
      &:last-child {
        border-right: none;
      }
    }
    b {
      position: relative;
      &::after {
        content: "我";
        position: absolute;
        top: -6px;
        right: -17px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        color: #d2934f;
        border-radius: 50%;
        background-color: #ffffff;
      }
    }
  }
  .leaderboard-differ {
    position: relative;
    justify-content: center;
    border-top: 1px solid #ffffff;
    z-index: 1;
  }
  .leaderboard-list {
    height: 400px;
    overflow-y: scroll;
  }
  .notLeaderboard {
    height: 205px;
    line-height: 205px;
    text-align: center;
    background-color: #fff8f1;
    img {
      width: 135px;
      height: 135px;
      vertical-align: middle;
    }
  }
  .leaderboard-awarded {
    height: 49px;
    line-height: 49px;
    font-size: 13px;
    font-weight: bold;
    color: #d2934f;
    text-align: center;
  }
  .line {
    position: relative;
    &::before {
      content: "";
      width: 1px;
      height: 30px;
      position: absolute;
      background-color: #f4f4f4;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 100;
    }
  }
  .rule-image {
    width: 340px;
    margin: 15px auto 0;
    padding-bottom: 10px;
    img {
      width: 100%;
      display: block;
    }
  }
}
.notHave {
  min-height: calc(100vh - 44px);
  background-color: #221815;
}
</style>
<style scoped>
.leaderboard >>> .van-tab {
  font-weight: bold;
}
.leaderboard >>> .van-tab--active {
  font-size: 16px;
}
.leaderboard >>> .van-tabs__line {
  background-color: #ff7b2b;
}
</style>